export default {
  referencePointEffectiveImpedance: "Bezugsort der wirksamen Impedanz",
  temporaryMinimumPerformance: "Vorübergehende Mindestleistung",
  animation: {
    description:
      "Ihre Filter haben keine Ergebnisse ergeben. Bitte versuchen Sie es erneut, indem Sie Ihre Filter anpassen oder löschen.",
    title: "Keine passenden Suchergebnisse",
  },
  zerezIdforUnit: "ZEREZ ID der Einheit",
  zerezIdforCertificate: "ZEREZ ID des Zertifikates",
  certificateCheck: "Zertifikatsprüfung",
  certificateHistory: "Zertifikatsverlauf",
  certificateSequence: "Zertifikatsfolge",
  instantaneousReserve: "Momentanreserveparameter",
  requestMatrixParametersText: "Zugriff auf Momentanreserveparameter anfordern",
  accessApprovedMatrixParametersText: "Zugriff auf Momentanreserveparameter genehmigt",
  parameterView: "Parameteransicht",
  certificateHistoryClose: "Zertifikatsverlauf schließen",
  certificateHistoryIssues: {
    "4e7118b6-4883-567a-b4ad-ab245717ff08": "Fehlerbericht erstellt",
    "9524be5a-6656-548a-a3c1-754b20df564a": "Zertifikat verifiziert",
    "b3ef1a67-6644-568f-b8d2-898b2d897562": "Zertifikat hochgeladen",
    "b01df1c0-0ea3-5313-bd0c-54931887c428": "Fehlerbericht geprüft",
  },
  certificateHistoryIssueTypesAndStatus: {
    "4e7118b6-4883-567a-b4ad-ab245717ff08": {
      // error report
      "24c5e9ce-5ab1-5b2a-bdcf-9b72375ddbd6": "Fehlerbericht bestätigt",
      "3ef6203f-08a9-5d5b-abb7-a9f6140c0c88": "Fehlerbericht abgelehnt",
      "5ab495d4-c024-5919-8a46-7bb6a350d901": "Fehlerbericht gelöst",
      "dc7a63d2-6f9c-5604-ab6b-5e35656d017f": "Fehlerbericht durch Admin geschlossen",
      default: "Fehlerbericht",
    },
    "9524be5a-6656-548a-a3c1-754b20df564a": {
      // certificate validation
      "2cb21769-d5e7-5c7b-92a9-66c7cec83c4a": "Zertifikat hochgeladen", // new
      "c5aecfb8-5509-581c-a020-ee346f9775e2": "Upload korrigiert", // open
      "7e940e8c-3b72-586e-bd8b-82a8fbe9f497": "Korrektur abgeschlossen", // pending review
      "dc7a63d2-6f9c-5604-ab6b-5e35656d017f": "Zertifikat verifiziert", // closed
      "f29219b3-0298-512b-bf64-4dbcc7bfb99f": "Zertifikat reduziert hochgeladen (nach TR8)", // newTG8
      "6c00e34b-d503-56c3-8992-5783701ebb43": "Upload korrigiert", // openTG8
      "d90ddbba-5776-5cee-bcd2-cda47bd798bf": "Validierung neu gestartet", // reopened
      "ab932a80-ee8e-5ab7-b70a-9ad957fac15f": "Neuzuweisung durch Admin", // reassignment
      "451ff4cf-418a-50d9-96c0-ddaf6e920fb7": "Gültigkeit erweitert", // NewExtension
      "0b2e5b56-dc16-5210-a744-5396f2b6e892": "Zertifikat ersetzt", // NewReplacement
      "3ef6203f-08a9-5d5b-abb7-a9f6140c0c88": "Korrektur angefordert", // rejected
      "1bb5e2c9-9b9a-59a4-8290-2d62fe246a7e": "Ungültig (durch Admin)", // VoidByPO
      "2644f649-0882-55fc-a26a-f0a250d71c1e": "Ungültig (durch Zertifizierungsstelle)", // VoidByCB
      ERROR_IN_VERIFICATION_PROCESS: "Fehler im Verifikationsprozess", // error in verification process
      default: "Zertifikatsvalidierung",
    },
    "b3ef1a67-6644-568f-b8d2-898b2d897562": {
      // import
      default: "Import",
    },
    "b01df1c0-0ea3-5313-bd0c-54931887c428": {
      // error correction
      "c5aecfb8-5509-581c-a020-ee346f9775e2": "Zertifikat bearbeitet", // open
      "13ef0cf5-fccb-5293-b7a6-7b1bdbe40da7": "Zertifikat erneut bearbeitet", // in progress
      "7e940e8c-3b72-586e-bd8b-82a8fbe9f497": "Korrektur abgeschlossen", // pending review
      "dc7a63d2-6f9c-5604-ab6b-5e35656d017f": "Korrektur akzeptiert", // closed
      "ab932a80-ee8e-5ab7-b70a-9ad957fac15f": "Neuzuweisung durch Admin", // reassignment
      "451ff4cf-418a-50d9-96c0-ddaf6e920fb7": "Gültigkeit erweitert", // NewExtension
      "0b2e5b56-dc16-5210-a744-5396f2b6e892": "Zertifikat ersetzt", // NewReplacement
      "3ef6203f-08a9-5d5b-abb7-a9f6140c0c88": "Korrektur angefordert", // rejected
      "1bb5e2c9-9b9a-59a4-8290-2d62fe246a7e": "Ungültig (durch Admin)", // VoidByPO
      "2644f649-0882-55fc-a26a-f0a250d71c1e": "Ungültig (durch Zertifizierungsstelle)", // VoidByCB
      default: "Fehlerberichtigung",
    },
  },
  certificateInfo: "Zertifikatsinformationen",
  certificateStatus: "Zertifikatstatus",
  certificateStatuses: {
    expired: "Abgelaufen",
    expiring: "Läuft ab",
    replaced: "Zurückgezogen (ersetzt durch)",
    valid: "Gültig",
    withdrawn: "Zurückgezogen (nicht ersetzt)",
  },
  description:
    "Die FGW e.V. vernetzt die Energiebranche und vereinheitlicht außerdem die Fachsprache der dezentralen und erneuerbaren Energien. In diesem Abschnitt finden Sie die Einheiten- und Komponentenzertifikate für die verschiedene Spannungsebenen. Hier können Sie überprüfen, ob diese Zertifikate von einer akkreditierten Zertifizierungsstelle geprüft wurden und ihren aktuellen Gültigkeitsstatus einsehen.",
  editParameters: "Parameter bearbeiten",
  editCertificate: "Zertifikat bearbeiten",
  errorNote: ({ entity, modelName }: { entity: "unit" | "certificate"; modelName: string | undefined }) => {
    let errorNote = `Bitte beschreiben Sie das Problem, das Sie bei dem Zertifikat ${modelName} festgestellt haben. Sobald das Problem von der verantwortlichen Partei behoben wurde, werden Sie per E-Mail benachrichtigt.`;
    if (entity === "unit")
      errorNote = `Bitte beschreiben Sie das Problem, das Sie bei dem Gerät ${modelName} festgestellt haben. Sobald das Problem von der verantwortlichen Partei behoben wurde, werden Sie per E-Mail benachrichtigt.`;
    return errorNote;
  },
  unitEditWarning: {
    header: "Bitte verlassen Sie den Bearbeitungsmodus, um fortzufahren.",
    info: "Sie bearbeiten derzeit die Parameter einer Einheit. Mögliche Änderungen gehen möglicherweise verloren. Bitte verlassen Sie den Bearbeitungsmodus, um fortzufahren.",
  },
  filterTitles: {
    certificateStatus: "Zertifikatstatus",
    certificateType: "Nachweisdokument",
    authority: "Zertifizierungsstelle",
    manufacturer: "Hersteller",
    maxActivePower: "Maximale Wirkleistung",
    norm: "Norm",
    ownCertificates: "Eigene Zertifikate",
    primaryEnergy: "Primärenergie",
    ratedPower: "Wirkleistung",
    ratedVoltage: "Bemessungsspannung",
    subscribed: "Abonniert",
    verified: "Verifiziert",
    isNotReplaced: "Nur aktuelle Revisionen",
    zerezId: "ZEREZ ID",
    hasMatrixParameters: "Netzbildende Einheit",
    sortByCreatedAt: "Erstellungsdatum (Zertifikat)",
    sortByModifiedAt: "Änderungsdatum (Zertifikat)",
    errorReportStatus: "Fehlerberichtstatus",
    certificateHolder: "Zertifikatsinhaber",
  },
  label: "Einheiten und Zertifikate",
  locked: "Gesperrt",
  mostRecentCertificate: "Neuestes Zertifikat",
  notVerified: "Nicht Verifiziert",
  verificationPending: "Verifizierung ausstehend",
  isErrorReportedUnresolved: "Offener Fehlerbericht",
  verify: "Verifizieren",
  referToDetailView: "siehe Detailansicht",
  reportCertificateError: "Zertifikatsfehler melden",
  showUnit: "Zur Einheit",
  since: "seit",
  subscribed: "Abonniert",
  subscribeStar: "Abonnement",
  subscribe: "Abonnieren",
  title: "ZEREZ - Zentrales Register für Einheiten- und Komponentenzertifikate",
  unitParameters: {
    netFeed: "Typen Information",
    electricalParameters: "Elektrische Parameter",
    fastVoltageChanges: "Schnelle Spannungsänderungen",
    operation1: "Schaltvorgang 1",
    operation2: "Schaltvorgang 2",
    operation3: "Schaltvorgang 3",
    flicker: "Flicker",
    generalInfo: "Allgemeine Informationen",
    label: "Geräteparameter",
    powerRanking: "Leistungsbewertung",
  },
  uploadedDocuments: "Hochgeladene Dokumente",
  units: "Einheiten",
  noUnitsFound: "Zu ihrer Sucheingabe wurden keine Einheiten gefunden",
  verified: "Verifiziert",
  inCorrection: "Feedbackverfahren läuft",
  linkToDetailPageOfModel: "Link zur Detailseite der Einheit",
  listOfConnectionValues: "Liste der Netzanschlusswerte",
  zerezIDTextforPowerRange: "siehe Schieber für Leistungsbereich",
  requestLockedData: {
    sendRequest: "Anfrage senden",
    title: "Zugriff anfordern",
    selectAll: "Alle auswählen",
    selected: "ausgewählt",
    accessRequested: "...Zugriff angefordert",
    accessDenied: "...Zugriff abgelehnt",
    noRequestablesSelected:
      "Um Zugriff anzufordern, wählen Sie bitte die Art der Informationen aus, auf die Sie zugreifen möchten.",
    requestConnectionValuesText:
      "Ich möchte Zugriff auf die vollständige Liste der Netzanschlusswerte für alle Einheiten haben, die von diesem Zertifikat abgedeckt sind.",
    accessApprovedConnectionValuesText: "Sie haben Zugriff auf die vollständige Liste der Netzanschlusswerte",
    requestAccesNetworkConnectionValues:
      "Mit Ihrer aktuellen Berechtigung haben Sie keinen Zugriff auf die unten aufgeführten Daten. Um diese einsehen zu können, fordern Sie Zugriff an.",
    requestAccesNetworkConnectionValuesPending:
      "Der Zugriff auf einige gesperrte Dokumente wurde bereits von Ihnen oder einem Mitglied Ihrer Organisation angefordert. Sie erhalten eine E-Mail-Benachrichtigung, sobald der Zertifikatsinhaber die Anforderung genehmigt oder ablehnt.",
    noMatrixParameterAccess: "Sie haben keine Berechtigung, die Matrix-Parameter dieser Einheit anzuzeigen.",
    privacyNotice:
      " Mit Einreichen der Anfrage auf Dokumenteneinsicht willige ich ein, dass die Organisation, die dieses Zertifikat besitzt, meine E-Mail-Adresse erhält, um mich für eventuelle Rückfragen kontaktieren zu können!",
  },
  zerezIDForPowerRange: "ZEREZ ID für Leistungsbereich",
  historization: {
    open: "offen",
    added: "hinzugefügt",
    updated: "aktualisiert",
    removed: "entfernt",
    errorReportCreatedByAt: ({ tenantName, createdAt }: { tenantName: string; createdAt: string }) =>
      `Gemeldet von ${tenantName} am ${createdAt}`,
    originalErrorReportMessage: "Ursprüngliche Fehlerberichtsmeldung",
  },
  certificateWithTG8Rev25ConformityDisclaimer:
    "Dieses Nachweisdokument wurde gemäß TR 8 Rev. 9 hochgeladen. Eine ZEREZ-ID wird erst nach Vervollständigung aller Pflichtangaben erteilt.",
  certificateChainWithdrawWarningTitle: "Zertifikat ist Teil einer Kette",
  certificateChainWithdrawWarningDescription:
    "Dieses Zertifikat ist Teil einer Gültigkeitserweiterung. Falls Sie den Gültigkeitsstatus auf Zurückgezogen (nicht ersetzt) setzen, wird die gesamte Zertifikatskette widerrufen. Möchten Sie mit der Bearbeitung fortfahren?",
  certificateChainReplaceWarningDescription:
    "Dieses Zertifikat ist Teil einer Gültigkeitserweiterung. Falls Sie das Zertifikat ersetzen, wird die gesamte Zertifikatskette widerrufen. Möchten Sie mit der Bearbeitung fortfahren?",
  certificateChainWithdrawWarningConfirm: "Bearbeitung fortsetzen",
  certificateChainReplaceWarningConfirm: "Fortfahren",
  certificateChainWithdrawWarningCancel: "Abbrechen",
  certificateChainList: "Zertifikate in dieser Kette",
  reorderChain: {
    buttonLabel: "Kette neu ordnen",
    modalTitle: "Ersetzungskette neu ordnen",
    description: "Ziehen Sie die Zertifikate per Drag & Drop auf der rechten Seite in die gewünschte Reihenfolge.",
    currentOrderLabel: "Aktuelle Reihenfolge",
    newOrderLabel: "Neue Reihenfolge",
    baseCertificate: "Basis",
    successor: "Revision",
    successMessage: "Reihenfolge der Zertifikatskette wurde erfolgreich aktualisiert.",
    errorMessage: "Fehler beim Aktualisieren der Kettenreihenfolge.",
  },
  gridFormingUnitTooltip: "Netzbildende Einheit",
};
